import moment from "moment";
import { formateDate } from "./formats.js";

export function isValidCNPJ(value) {
    if (!value) return false;

    // Elimina CNPJs invalidos conhecidos
    if (value == "00000000000000" || 
        value == "11111111111111" || 
        value == "22222222222222" || 
        value == "33333333333333" || 
        value == "44444444444444" || 
        value == "55555555555555" || 
        value == "66666666666666" || 
        value == "77777777777777" || 
        value == "88888888888888" || 
        value == "99999999999999")
        return false;

    // Aceita receber o valor como string e converte letras para maiúsculas
    let cnpjStr = value.toString().replace(/[^a-zA-Z0-9]/g, '').toUpperCase();
    
    if (cnpjStr.length !== 14) return false;

    // Elimina inválidos com todos os caracteres iguais
    const items = [...new Set(cnpjStr)];
    if (items.length === 1) return false;

    // A partir de 2026, as 12 primeiras posições podem ser alfanuméricas
    // As 2 últimas (dígitos verificadores) devem ser numéricas
    if (!/^[A-Z0-9]{12}\d{2}$/.test(cnpjStr)) return false;

    // Função para converter caractere para número conforme nova regra (ASCII - 48)
    const charToNumber = (char) => {
        return char.charCodeAt(0) - 48;
    };

    // Cálculo validador
    const calc = (x) => {
        let factor = x - 7;
        let sum = 0;

        for (let i = x; i >= 1; i--) {
            const char = cnpjStr[x - i];
            const num = charToNumber(char);
            sum += num * factor--;
            if (factor < 2) factor = 9;
        }

        const result = 11 - (sum % 11);
        return result > 9 ? 0 : result;
    };

    const digit0 = calc(12);
    if (digit0 !== parseInt(cnpjStr[12])) return false;

    const digit1 = calc(13);
    if (digit1 !== parseInt(cnpjStr[13])) return false;

    return true;
}

export function isValidCPF(cpf) {
    if (typeof cpf !== "string") return false
    cpf = cpf.replace(/[\s.-]*/igm, '')
    if (
        !cpf ||
        cpf.length != 11 ||
        cpf == "00000000000" ||
        cpf == "11111111111" ||
        cpf == "22222222222" ||
        cpf == "33333333333" ||
        cpf == "44444444444" ||
        cpf == "55555555555" ||
        cpf == "66666666666" ||
        cpf == "77777777777" ||
        cpf == "88888888888" ||
        cpf == "99999999999" 
    ) {
        return false
    }
    var soma = 0
    var resto
    for (var i = 1; i <= 9; i++) 
        soma = soma + parseInt(cpf.substring(i-1, i)) * (11 - i)
    resto = (soma * 10) % 11
    if ((resto == 10) || (resto == 11))  resto = 0
    if (resto != parseInt(cpf.substring(9, 10)) ) return false
    soma = 0
    for (var i = 1; i <= 10; i++) 
        soma = soma + parseInt(cpf.substring(i-1, i)) * (12 - i)
    resto = (soma * 10) % 11
    if ((resto == 10) || (resto == 11))  resto = 0
    if (resto != parseInt(cpf.substring(10, 11) ) ) return false
    return true
}

export function isValidDate(input_date){
    input_date = formateDate(input_date);
    var year = moment(input_date.toString(), "DD/MM/YYYY").year();

    if (year < 1000 || year > 3000)
        return false;

    return moment(input_date.toString(), "DD/MM/YYYY", true).isValid();
}

export function isValidHourMinute(input_date){
    return moment(input_date.toString(), "HH:mm", true).isValid();
}

export function isValidDayMonth(input_date){
    return moment(input_date.toString(), "DD/MM", true).isValid();
}

export function onlyNumber(input_text){
    input_text = input_text.replace(/[^0-9]+/g, '');
    return input_text;
}

export function onlyAlphaNumericAndSpace(input_text){
    input_text = input_text.replace(/[^A-zÀ-ú0-9\w\s\&]/gi,'');
    return input_text;
}